<script setup lang="ts">
import type { TooltipArrowProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { TooltipArrow } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<TooltipArrowProps & { class?: HTMLAttributes['class'] }>()

const delegated = reactiveOmit(props, 'class')
</script>

<template>
  <TooltipArrow v-bind="delegated" :class="cn('fill-dark/90', props.class)" />
</template>
